import { useQuery } from "@tanstack/react-query";
import { readClientsClientsGet } from "@/client-admin";
import { LoadingComponent } from "@/components/LoadingComponent";
import { columns } from "./columns";
import { DataTable } from "./data-table";

export function ClientsTable() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["clients"],
    queryFn: () => readClientsClientsGet(),
  });

  if (isLoading) return <LoadingComponent />;
  if (isError) return <div>Error loading clients</div>;
  if (!data) return <div>Data not loaded</div>;

  return <DataTable columns={columns} data={data.data} />;
}
